<template>
  <div class="Login">
    <div class="LoginContentWrap">
      <div class="LoginTitle"><p><strong>Hello!</strong> 请登录...</p></div>
      <div class="InputWrap flexbetween">
        <div class="CloseBox" @click="closeWindow"><img src="../assets/Home/exit1.png"></div>
        <div class="CodeWrap">
          <i style="margin-top: 0.4rem"><img src="../assets/Home/logo1.png"></i>
<!--          <p>使用手机打开 GoeasyApp 扫描上方二维码登录</p>-->
        </div>
        <div  class="InputContentWrap">
          <div class="flex TabLog">
            <div class="flex" @click="tab('pass')" :class="{Active:this.tabstate}"><span>账号登录</span></div>
            <div class="flex" @click="tab('code')" :class="{Active:!this.tabstate}"><span>短信登录</span></div>
          </div>
          <div v-if="tabstate">
          <div class="Password">
            <div class="Input flexa"><input placeholder="请输入账号" onkeyup="value=value.replace(/[\W]/g,'')"
                                            v-model="loginInfo.id" @keyup.enter="Submit('password')"></div>
            <div class="Input SendCode flexa"><input placeholder="请输入密码" type="password"
                                                     v-model="loginInfo.password" @keyup.enter="Submit('password')"></div>
          </div>
          <div class="SubmitButton flex" @click="Submit('password')"><span>登录</span></div>
          <div class="Find flex">
            <slot></slot>
          </div>
          </div>
          <div v-else>
            <div class="Password">
              <div class="Phone">
                <div class="Input flexa"><input placeholder="输入手机号" @blur="checkToShowMsgBtn" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="forgetPasswdData.phone"></div>
                <div class="Input SendCode flexa"><input placeholder="输入图形验证码" maxlength="4" onkeyup="value=value.replace(/[^\d]/g,'')" @blur="checkToShowMsgBtn" v-model="forgetPasswdData.imgCode">
                  <div class="flex Send codes" @click="requestImgCode"><img :src="imgCodeSrc"></div>
                </div>
                <!-- v-show="isMsgCodeShow"-->
                <div class="Input SendCode flexa"><input placeholder="输入验证码" maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="forgetPasswdData.code">
                  <div class="flex Send" @click="requestMessageCode(forgetPasswdData.phone)"><span>{{Text}}</span></div>
                </div>
              </div>
            </div>
            <div class="SubmitButton flex" @click="Submit('phonecode')"><span>登录</span></div>
            <div class="Find flex">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
      <div class="NeedKnown"><p>登录即代表您同意<span @click="OpenUrl('https://www.goeasy.cn/ys.html')">隐私协议</span>和<span @click="OpenUrl('https://www.goeasy.cn/fw.html')">服务条款</span></p></div>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import axios from 'axios';
  export default {
    name: 'LoginPopWindow',
    inject: [
      'load'
    ],
    components: {},
    props: {},
    data () {
      return {
        tabstate: true,
        forgetPasswdData: {
          phone: '',
          code: '',
          imgCode: '',
          newPasswd: '',
          newPasswdAgain: '',
          regid: '',
          smsid: ''
        },
        loginInfo: { id: '', password: '' },
        i: 60,
        Text: '发送验证码',
        isMsgCodeShow: false,
        imgCode: '',
        imgCodeSrc: '',
        noclickFlag: false
      };
    },
    created () {
      this.requestImgCode();
    },
    methods: {
      tab(type) {
        if (type === 'pass') {
          this.tabstate = true;
        } else {
          this.tabstate = false;
        }
      },
      requestMessageCode(phone) {
        if (!this.noclickFlag) {
          if (this.$utils.checkPhoneNumber(phone)) {
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: `${this.$userMangerUrl}user/v1/check/${phone}/2`
            }).then((data) => {
              if (data.status === 200) {
                data = data.data;
                if (data.code === 1) {
                  this.noclickFlag = true;
                  this.reqMsgInterval = setInterval(() => {
                    if (this.i === 0) {
                      this.Text = '发送验证码';
                      this.i = 60;
                      this.noclickFlag = false;
                      clearInterval(this.reqMsgInterval);
                      return;
                    }
                    this.Text = this.i-- + 's';
                  }, 1000);
                  this.forgetPasswdData.smsid = this.$utils.randomstring(6);
                  axios({
                    method: 'GET',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    url: `${this.$userMangerUrl}user/v1/smsvercode/${phone}`,
                    params: {
                      imgcode: this.forgetPasswdData.imgCode,
                      regid: this.forgetPasswdData.regid,
                      smsid: this.forgetPasswdData.smsid
                    }
                  }).then(res => {
                    if (res.data.code !== 0) {
                      this.$message({
                        message: res.data.msg,
                        type: 'error'
                      });
                      this.Text = '发送验证码';
                      this.i = 60;
                      this.noclickFlag = false;
                      clearInterval(this.reqMsgInterval);
                    } else {
                      this.$message({
                        message: `短信验证码已发送至手机号${phone}，请注意查收`,
                        type: 'success'
                      });
                    }
                  });
                } else if (data.code === 0) {
                  this.$message({
                    message: '手机号对应用户不存在，请注册或检查手机号重试。',
                    type: 'warning'
                  });
                }
              } else {
                this.$message.error(data.statusText);
              }
            }, err => {
              this.$message.error(err);
            });
          } else {
            this.$message({
              message: '输入的手机号不正确,请重新输入',
              type: 'warning'
            });
          }
        }
      },
      requestImgCode() {
        this.forgetPasswdData.regid = this.$utils.randomstring(6);
        axios({
          method: 'GET',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          url: `${this.$userMangerUrl}user/v1/applyimgcode?regid=${this.forgetPasswdData.regid}&width=200&height=60&x=10&y=-5&jj=36&fontsize=36`
        }).then((res) => {
          console.log(res);
          if (res.status === 200 && res.data.code === 0) {
            this.imgCodeSrc = res.data.data.img;
            this.imgCode = res.data.data.code;
          }
        });
      },
      OpenUrl(url) {
        window.open(url, '_blank');
      },
      closeWindow() {
        this.$emit('closeWindow');
      },
      checkToShowMsgBtn() {
        this.isMsgCodeShow = this.forgetPasswdData.phone && this.forgetPasswdData.imgCode === this.imgCode;
      },
      async Submit(type) {
        let res = null;
        if (type === 'password') {
          this.load.show();
          res = await this.userLogin(this.loginInfo);
        } else {
          if (!this.forgetPasswdData.phone) {
            this.$message({
              message: '请输入手机号',
              type: 'warning'
            });
            return;
          }
          if (!this.forgetPasswdData.imgCode) {
            this.$message({
              message: '请输入图形验证码',
              type: 'warning'
            });
            return;
          }
          if (!this.forgetPasswdData.smsid) {
            this.$message({
              message: '请点击发送验证码',
              type: 'warning'
            });
            return;
          }

          if (!this.forgetPasswdData.code) {
            this.$message({
              message: '请输入短信验证码！',
              type: 'warning'
            });
            return;
          }
          this.load.show();
          let data = { id: this.forgetPasswdData.phone, smscode: this.forgetPasswdData.code, imgcode: this.forgetPasswdData.imgCode, regid: this.forgetPasswdData.regid, smsid: this.forgetPasswdData.smsid };
          res = await this.userLogin(data);
        }
        if (res.code === 0) {
          res = res.data;
          console.log(res.systemlst.length);
          // 登录框关闭
          // this.LoginPopWindow = false;
          // this.IsLog = true;

          this.load.hide();
          if (res.systemlst.length > 1) {
            // this.ChangeState = true; 选择系统打开
            this.$emit('chooseSystem');
            this.closeWindow();
          } else if (res.systemlst.length === 1) {
            this.setCurrentSystem({ name: res.systemlst[0].name, code: res.systemlst[0].id });
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: this.$loginUrl + 'api/login/seteom', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
              params: {
                userid: res.user.userId,
                eom: res.systemlst[0].id,
                getportal: 1
              }
            }).then((data) => {
              if (data.status === 200 && data.data.code === 0) {
                this.$emit('GetInitWorkData');
                localStorage.setItem('GoeasyServicelst', JSON.stringify(data.data.data.servicelst));
                sessionStorage.setItem('GoeasyServicelst', JSON.stringify(data.data.data.servicelst));
                this.closeWindow();
              } else {
                console.log(data.data.msg);
              }
            }, err => {
              console.log(err);
            });
          } else if (res.systemlst.length === 0) {
            this.closeWindow();
          }

          window.goeasyLoginTime = Date.now();
        } else if (res.code === -1) {
          this.load.hide();
          this.$message.error(res.msg);
        }
      },
      ...mapActions(['userLogin', 'setCurrentSystem'])
    }
  };
</script>
<style lang="scss" scoped>
@import '../../public/Value';
.Login {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 8;
  display: flex;
  -webkit-justify-content: center;
  -webkit-align-items: center;
  .LoginContentWrap {
    width: 2.7rem;
    height: 2.2rem;
    border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
    background: linear-gradient(to bottom right, #6666cc, #4141b3);
    position: relative;

    .CloseBox {
      width: 0.15rem;
      height: 0.15rem;
      position: absolute;
      cursor: pointer;
      right: 0.05rem;
      top: 0.05rem;
      z-index: 6;

      img {
        width: 100%;
      }
    }

    .NeedKnown {
      position: absolute;
      width: 100%;
      bottom: 0.1rem;

      p {
        font-size: $SmallTextSize;
        color: #fff;
        text-align: center;

        span {
          cursor: pointer;
          font-weight: bold;
          margin: 0 0.02rem;
          color: #999900;
        }
      }
    }
    .InputWrap {
      width: 2.4rem;
      margin: 0.1rem auto 0;

      .InputContentWrap {
        width: 50%;
        margin-top: 0.1rem;
        .TabLog {
          width: 1rem;
          margin: 0 auto 0.1rem;

          div {
            width: 50%;
            height: 0.2rem;
            cursor: pointer;
            opacity: 0.6;

            span {
              font-size: $TextSize;
              color: #fff;
            }
          }

          .Active {
            border-bottom: 3px solid #b2e4fc;
            opacity: 1;
          }
        }
        .Find{
          width: 1rem;
          margin: 0.08rem auto 0.1rem;
          p{
            font-size: $AdditionTextSize;
            color: #fff;
            margin: 0 0.05rem;
            text-align: center;
            cursor: pointer;
          }
        }
        .SubmitButton {
          width: 1rem;
          height: 0.15rem;
          border-radius: 0.3rem;
          background-color: #fff;
          margin: 0.15rem auto 0;
          cursor: pointer;
          box-shadow: 5px 5px 15px #47478c;

          span {
            font-size: $TextSize;
            color: #4848b8;
          }
        }

        .AnotherLoginWrap {
          width: 100%;

          i {
            width: 0.4rem;
            height: 2px;
            background-color: #fff;
          }

          span {
            margin: 0 0.07rem;
            font-size: $SmallTextSize;
            color: #fff;
          }

          .IconWrap {
            width: 100%;
            margin-top: 0.05rem;
            i {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 0.2rem;
              cursor: pointer;
              margin: 0 0.08rem;
              img {
                width: 100%;
                height: 100%;
                border-radius: 0.2rem;
              }
            }
          }
        }

        .Input {
          width: 1rem;
          height: 0.18rem;
          border-bottom: 2px solid #fff;
          margin: 0 auto 0.1rem;

          input {
            width: 0.6rem;
            color: #fff;
            height: 100%;
            margin-left: 0.03rem;
            font-size: $AdditionTextSize;
            background-color: rgba(255,255,255,0) !important;

            &:-webkit-autofill{
              transition: background-color 5000s ease-in-out 0s;
              -webkit-text-fill-color: #fff !important;
            }
            &:-webkit-autofill:focus {
              -webkit-text-fill-color: #fff !important;
            }
            &::-moz-placeholder{
              color: #fff;
            }
            &::-webkit-input-placeholder {
              color: #fff;
              opacity: 0.6;
              font-size: $AdditionTextSize;
            }
          }

          .Send {
            width: 0.4rem;
            height: 0.12rem;
            background-color: #fff;
            border-radius: 0.1rem;
            cursor: pointer;
            box-shadow: 5px 5px 15px #47478c;

            span {
              font-size: $SmallTextSize;
              color: #4848b8;
            }
          }
        }
      }

      .CodeWrap {
        width: 50%;

        i {
          width: 1rem;
          margin: 0.15rem auto 0;

          img {
            width: 100%;
          }
        }

        p {
          margin-top: 0.07rem;
          font-size: $SmallTextSize;
          color: #fff;
          text-align: center;
        }
      }
      /*.CodeWrap{*/
      /*  i{*/
      /*    width: 1rem;*/
      /*    margin: 0.4rem auto 0 !important;*/
      /*  }*/
      /*}*/
      .codes{
        background-color: transparent !important;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
/*    .InputWrap {
      width: 2.4rem;
      margin: 0.1rem auto 0;

      .InputContentWrap {
        width: 50%;
        margin-top: 0.1rem;
        .TabLog {
          width: 1rem;
          margin: 0 auto 0.1rem;

          div {
            width: 50%;
            height: 0.2rem;
            cursor: pointer;
            opacity: 0.6;

            span {
              font-size: $TextSize;
              color: #fff;
            }
          }

          .Active {
            border-bottom: 3px solid #b2e4fc;
            opacity: 1;
          }
        }
        .Find{
          width: 1rem;
          margin: 0.08rem auto 0.1rem;
          p{
            font-size: $AdditionTextSize;
            color: #fff;
            margin: 0 0.05rem;
            text-align: center;
            cursor: pointer;
          }
        }
        .SubmitButton {
          width: 1rem;
          height: 0.15rem;
          border-radius: 0.3rem;
          background-color: #fff;
          margin: 0.15rem auto 0;
          cursor: pointer;
          box-shadow: 5px 5px 15px #47478c;

          span {
            font-size: $TextSize;
            color: #4848b8;
          }
        }

        .AnotherLoginWrap {
          width: 100%;

          i {
            width: 0.4rem;
            height: 2px;
            background-color: #fff;
          }

          span {
            margin: 0 0.07rem;
            font-size: $SmallTextSize;
            color: #fff;
          }

          .IconWrap {
            width: 100%;
            margin-top: 0.05rem;
            i {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 0.2rem;
              cursor: pointer;
              margin: 0 0.08rem;
              img {
                width: 100%;
                height: 100%;
                border-radius: 0.2rem;
              }
            }
          }
        }

        .Input {
          width: 1rem;
          height: 0.18rem;
          border-bottom: 2px solid #fff;
          margin: 0 auto 0.1rem;

          input {
            width: 0.6rem;
            color: #fff;
            height: 100%;
            margin-left: 0.03rem;
            font-size: $AdditionTextSize;
            background-color: rgba(255,255,255,0) !important;

            &:-webkit-autofill{
              transition: background-color 5000s ease-in-out 0s;
              -webkit-text-fill-color: #fff !important;
            }
            &:-webkit-autofill:focus {
              -webkit-text-fill-color: #fff !important;
            }
            &::-moz-placeholder{
              color: #fff;
            }
            &::-webkit-input-placeholder {
              color: #fff;
              opacity: 0.6;
              font-size: $AdditionTextSize;
            }
          }

          .Send {
            width: 0.4rem;
            height: 0.12rem;
            background-color: #fff;
            border-radius: 0.1rem;
            cursor: pointer;
            box-shadow: 5px 5px 15px #47478c;

            span {
              font-size: $SmallTextSize;
              color: #4848b8;
            }
          }
        }
      }

      .CodeWrap {
        width: 50%;

        i {
          width: 1rem;
          margin: 0.15rem auto 0;

          img {
            width: 100%;
          }
        }

        p {
          margin-top: 0.07rem;
          font-size: $SmallTextSize;
          color: #fff;
          text-align: center;
        }
      }
    }*/

    .LoginTitle {
      width: 100%;
      margin-top: 0.05rem;

      p {
        font-size: $TextSize;
        color: #fff;
        text-indent: 0.05rem;
      }
    }
  }
}
</style>
